module.exports = __webpack_public_path__ + "static/media/Aider_Logo_PRIMARY.ae46b620.png";